import {useSelector} from "react-redux";
import {selectLang} from "state/selectors/router";

export default function useLang() {
    return useSelector(selectLang);
}